/** @format */

import $http from '../../shared/http';

export const ministries = {
  namespaced: true,
  state: () => {
    return {
      ministriesForSelect: null,
      maxNumberOfMinistriesPerMember: 2,
      ministryData: null,
      ministryFormData: null,
      isMinistryEdited: false,
      editedMinistryID: null,
      isMinistryCreated: null,
      createdMinistryID: null,
      existingMinistryNames: null,
      isFollowUpMinistryExist: null,
    };
  },
  getters: {
    getMinistriesForSelect: (state) => state.ministriesForSelect,
    getMaxNumberOfMinistriesPerMember: (state) => state.maxNumberOfMinistriesPerMember,
    getCurrentMinistry: (state) => state.ministryData,
    getEditedMinistryID: (state) => state.editedMinistryID,
    getIsMinistryEdited: (state) => state.isMinistryEdited,
    getCreatedMinistryID: (state) => state.createdMinistryID,
    getIsMinistryCreated: (state) => state.isMinistryCreated,
    getCurrentMinistryID: (state) => (state.ministryData ? state.ministryData.id : null),
    getMinistryEditData: (state) => state.ministryData,
    getMinistryEditFormData: (state) => state.ministryFormData,
    getMinistryRegisterFormData: (state) => state.ministryFormData,
    getExistingMinistryNames: (state) => state.existingMinistryNames,
    getIsFollowUpMinistryExist: (state) => state.isFollowUpMinistryExist,
  },
  mutations: {
    setMinistriesForSelect: (state, payload) => (state.ministriesForSelect = payload),
    setCurrentMinistry: (state, data) => {
      state.ministryData = data;
    },
    setMinistryEdited: (state, payload) => (state.isMinistryEdited = payload),
    setEditedMinistryID: (state, payload) => (state.editedMinistryID = payload),
    setMinistryCreated: (state, payload) => (state.isMinistryCreated = payload),
    setCreatedMinistryID: (state, payload) => (state.createdMinistryID = payload),
    clearResponseData: (state) => {
      state.ministryCreated = null;
      state.isMinistryEdited = null;
      state.newMinistryID = null;
      state.editedMinistryID = null;
    },
    setMinistryEditData(state, form) {
      state.ministryFormData = form;
    },
    setMinistryRegisterData(state, form) {
      state.ministryFormData = form;
    },
    setMinistryData: (state, data) => {
      state.ministryData = data;
    },
    setIsFollowUpMinistryExist: (state, data) => {
      state.isFollowUpMinistryExist = data;
    },
    setExistingMinistryNames: (state, data) => {
      state.existingMinistryNames = data;
    },
  },

  actions: {
    async LOAD_MINISTRIES_FOR_SELECT({ commit, rootGetters }, { churchId }) {
      const isLoggedInForSelfRegistration =
        rootGetters['membership_self_registrations/isLoggedInForSelfRegistration'];
      const selfRegistrationToken =
        rootGetters['membership_self_registrations/getSelfRegistrationToken'];

      if (!churchId && !isLoggedInForSelfRegistration) {
        throw new Error('Church ID not provided');
      }
      return $http('v2')
        .get(
          isLoggedInForSelfRegistration
            ? `membership_self_registrations/ministries/select?token=${selfRegistrationToken}`
            : `organisations/${churchId}/ministries/select`,
          { canBeImpersonated: true }
        )
        .then((response) => {
          commit('setMinistriesForSelect', response.data.data);
          return response;
        });
    },

    async loadMinistryData({ commit }, { id, churchId }) {
      commit('setMinistryData', null);
      return $http('v2')
        .get(`organisations/${churchId}/ministries/${id}`)
        .then((response) => {
          commit('setMinistryData', response.data.data);
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async createMinistryAction(ctx, { form, churchId }) {
      return $http('v2')
        .post(`organisations/${churchId}/ministries`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then(async (response) => {
          return response.data.data;
        });
    },

    async IS_FOLLOW_UP_MINISTRY_SET_ACTION({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/ministries/check/follow-up-ministry`, {
            canBeImpersonated: true,
          })
          .then((response) => {
            commit('setIsFollowUpMinistryExist', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async getMinistryNamesAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        commit('setExistingMinistryNames', null);
        await $http()
          .get(`/organisations/${churchId}/ministries/check/names`, { canBeImpersonated: true })
          .then((response) => {
            commit('setExistingMinistryNames', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
